import { render, staticRenderFns } from "./UploadingVideo.vue?vue&type=template&id=650e4a57&"
import script from "./UploadingVideo.vue?vue&type=script&lang=js&"
export * from "./UploadingVideo.vue?vue&type=script&lang=js&"
import style0 from "./UploadingVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports